module.exports = __webpack_public_path__ + "img/3d-transform_cn.c096acf.jpg";